const callEventHook = async (hookName: string) => {
  if (window.chHooks && window.chHooks[hookName]) {
    return await window.chHooks[hookName]()
  }
}

export default callEventHook
